export default __webpack_public_path__ + "static/media/img3.e79b0430.png";